import { ISeriesPrimitivePaneRenderer } from 'lightweight-charts'
import DrawingHandlePaneRenderer from './drawing.handle.paneRenderer'
import DrawingPaneView from './drawing.paneView'

class DrawingHandlePaneView extends DrawingPaneView {

    renderer(): ISeriesPrimitivePaneRenderer | null {
        return new DrawingHandlePaneRenderer({
            drawing: this.drawing,
            id: this.id
        })
    }
}


export default DrawingHandlePaneView